import { ICompanyLogoSelect } from './company-logo-selects';

export interface IUpdateCompanyLogos {
    data: ICompanyLogoSelect;
    del_items: string[];
}
